/** Must match `LANGUAGE_KEY` in `credentialsService` (do not import that file here — it imports i18n). */
const APP_LANGUAGE_KEY = "appLanguage";

/**
 * Resolved app language from session/localStorage.
 * SSR / no window: `"es"` (same default as previous hardcoded i18n).
 */
export function getStoredAppLanguage(): "en" | "es" {
  if (typeof window === "undefined") return "es";
  const raw =
    sessionStorage.getItem(APP_LANGUAGE_KEY) ||
    localStorage.getItem(APP_LANGUAGE_KEY);
  if (raw === "en" || raw === "es") return raw;
  return "es";
}
